// Powers the "More"/"Less" collapse toggle on product.description
// (sections/main-product.liquid, global across every product). The
// description ships server-rendered with the collapsed clamp class
// already applied (`.product-description--collapsed`, CSS-only max-height)
// so there is no flash of the full/uncollapsed description before this
// script runs. This script's only job is to MEASURE: it compares the
// content's real scrollHeight against the clamped clientHeight and only
// then reveals the fade overlay + toggle button (`.is-overflowing` on the
// wrapper) — short descriptions that never overflow the clamp stay exactly
// as they rendered before this feature existed, with no button shown.
// Re-measures on resize (debounced) since the clamp height is a fixed px
// value while content reflow (e.g. font swap, viewport width change) can
// change whether it actually overflows. Toggles via `aria-expanded` on the
// button, following the same pattern as assets/header.js's menu triggers.
(function () {
  function initToggle(root) {
    if (root.dataset.descriptionToggleInitialized === 'true') return;

    var content = root.querySelector('[data-description-content]');
    var button = root.querySelector('[data-description-toggle-btn]');
    var label = button && button.querySelector('[data-description-toggle-label]');
    if (!content || !button || !label) return;

    root.dataset.descriptionToggleInitialized = 'true';

    var moreText = button.dataset.moreLabel || label.textContent || 'More';
    var lessText = button.dataset.lessLabel || moreText;

    function measure() {
      var isExpanded = root.classList.contains('is-expanded');
      if (isExpanded) return; // already open — overflow state no longer matters

      // Force the clamp on to measure the true overflow, then compare.
      var overflowing = content.scrollHeight - content.clientHeight > 2;
      root.classList.toggle('is-overflowing', overflowing);
      button.classList.toggle('hidden', !overflowing);
    }

    button.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      content.classList.toggle('product-description--collapsed', !expanded);
      content.classList.toggle('product-description--expanded', expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? lessText : moreText;
      if (!expanded) {
        measure();
        root.scrollIntoView({ block: 'nearest' });
      }
    });

    measure();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-description-toggle]').forEach(initToggle);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  if (document.readyState !== 'loading') {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
